module.exports = __webpack_public_path__ + "static/media/eg.bf9a5d65.svg";